import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationSubscriptionsGet = {
    path: "/subscriptions",
    method: ERouteHttpVerb.GET
};
export { routeLocationSubscriptionsGet };
